import { stringOfEnum } from "@omnia/shared/utils/utils"
import { IOmniaShell, shell } from "../../../omnia"
import { StockVm } from "../../../stocks/stockVm"
import { INutritionPlanProductApp, INutritionService, INutritionTemplate, INutritionTemplateApp, NutrientType, ProductAppInput } from "../../../types"
import { sortReferenceDates } from "../../../utils"
import { IPlanEditContext } from "../types"
import { ProductApplicationVm } from "./productApplicationVm"

export class TemplatesCtrl {

    constructor(private svc: INutritionService, private ctxt: IPlanEditContext, private shell: IOmniaShell) {

    }

    saveTemplate(products: ProductApplicationVm[]): ng.IPromise<any> {

        if (!products || products.length === 0) {
            shell.showWarning(this.shell,
                "You cannot save an empty template. Please add products first.",
                "Template error");
            return;
        }

        var fertiliserApp = products.filter(p => !!p.productApp.Fertiliser);
        if (products.length !== fertiliserApp.length) {
            shell.showWarning(this.shell,
                "You can only save fertiliser templates.",
                "Template error");
            return;
        }

        var customProducts = products.filter(p => p.productApp.Fertiliser && p.productApp.Fertiliser.Custom);
        if (customProducts.length) {
            shell.showWarning(this.shell,
                "You can't save fertiliser application with custom stock analyis.",
                "Template error");
            return;
        }

        return this.shell.showComponentAsDialog("omnia-nutri-plan-template-edit", products, {
            backdrop: "static"
        });

    }

    manageTemplates(products: ProductApplicationVm[]): ng.IPromise<ProductApplicationVm[]> {

        return this.shell.showComponentAsDialog("omnia-nutri-plan-template-manage", (!products || products.length === 0), {
            backdrop: "static"
        }).then(r => {

            if (!r) return null;

            var template = <INutritionTemplate>r;
            var aborted = false;

            var completeApps = <ProductApplicationVm[]>[];

            template.Applications.forEach(a => {

                var app = <INutritionPlanProductApp>{
                    NutritionPlanId: 0,
                    NutritionPlanProductAppId: 0,
                    FertiliserId: null,
                    Fertiliser: null,
                    ManureId: 0,
                    GrowthStage: a.GrowthStage,
                    TargetNutrient: a.TargetNutrient,
                    ApplicationDate: this.getApplicationDateFromTemplateApp(a),
                    ProductRate: a.ProductAppInput === ProductAppInput.ProductRate ? a.Rate : undefined,
                    NutrientRate: a.ProductAppInput === ProductAppInput.NutrientRate ? a.Rate : undefined,
                    NutrientPct: a.ProductAppInput === ProductAppInput.NutrientPct ? a.Rate : undefined,
                    LastInputUsed: a.ProductAppInput
                };

                var stock = this.getFertiliserStockFromTemplateApp(a.FertiliserProductId);

                var nutrientValue = stock.getNutrientValue(stringOfEnum(NutrientType, a.TargetNutrient));
                if (!nutrientValue) {
                    aborted = true;
                    shell.showWarning(this.shell,
                        "The analysis of the stock '" +
                        stock.actualStock.Name +
                        "' has no value for the target nutrient of the application. Operation canceled.",
                        "Applying template failed");
                    return;
                }

                stock.updateProductApp(app, true);

                var product = new ProductApplicationVm(this.ctxt, this.svc, app);
                product.stock = stock;
                product.justAdded = false;

                if (a.Complete) {
                    completeApps.push(product);
                }

                products.push(product);
            });

            if (aborted) {
                products = [];
            } else {

                // Apply complete apps
                if (completeApps.length) {
                    completeApps = completeApps.sort((a, b) => sortReferenceDates(a, b));
                    completeApps.forEach(a => a.doAutoComplete());
                }
            }

            return products;

        });

    }

    private getFertiliserStockFromTemplateApp(fertiliserProductId: number): StockVm {

        let stocks = this.ctxt.stocks;

        var productStocks = stocks.filter(s => s.isFertiliser() && s.fertiliserProductId === fertiliserProductId);

        var notStock = productStocks.find(s => !s.stockId);
        var notCustomStock = productStocks.filter(s => s.actualStock && !s.actualStock.Custom);
        var stock = notCustomStock.length > 0 ? notCustomStock[0] : productStocks[0];

        return notStock ? notStock : stock;
    }

    private getApplicationDateFromTemplateApp(templateApp: INutritionTemplateApp): Date {

        var date = templateApp.ApplicationDate;

        // Handle 29 of Febuary to 28 of Febuary
        if (date.getMonth() === 1 && date.getDate() === 29 && !this.leapYear(this.svc.yearId)) {
            return new Date(this.svc.yearId, 1, 28);
        }

        return new Date(date.getFullYear() === 2012 ? this.svc.yearId : this.svc.yearId - 1, date.getMonth(), date.getDate());
    }

    private leapYear(year) {
        return ((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0);
    }


}
